/* global API_HOSTNAME:false */
/* global closest:false */
/* global dataLayer:false */
/* global Dialog:false */
/* global emailMisspelled:false */
/* global FormValidator:false */
/* global ga:false */
/* global getGetParameterByName:false */
/* global getStorageItem:false */
/* global isTouchDevice:false */
/* global removeStorageItem:false */
/* global resetAccessibleMessage:false */
/* global setAccessibleMessage:false */
/* global setStorageItem:false */
/* global tap:false */
/* global trigger:false */

(function () {
	var onboardingStep = '/go/';
	var onboardingUrlStep = '/go/url/';
	var onboardingEmailStep = '/go/email/';
	var onboardingConfirmationStep = '/go/confirmation/';
	var onboardingNotReceivedStep = '/go/not-received/';
	var onboardingSteps = [
		onboardingStep,
		onboardingUrlStep,
		onboardingEmailStep,
		onboardingConfirmationStep,
		onboardingNotReceivedStep,
	];

	var urlDialog = false;
	var emailDialog = false;
	var confirmationDialog = false;
	var reenterEmailDialog = false;
	var onboardingData = {};



	function prepareModals() {
		if (!urlDialog) {
			// prepare domain modal
			const urlDialogEl = document.querySelector('#onboarding-url');
			if (urlDialogEl) {
				urlDialog = new Dialog(urlDialogEl, {
					disableEscClose: true,
					urlRewrite: onboardingUrlStep,
				});
			}
		}

		if (!emailDialog) {
			// prepare email window
			const emailDialogEl = document.querySelector('#onboarding-email');
			if (emailDialogEl) {
				emailDialog = new Dialog(emailDialogEl, {
					disableEscClose: true,
					urlRewrite: onboardingEmailStep,
				});
			}
		}

		if (!confirmationDialog) {
			// prepare confirmation window
			const confirmationDialogEl = document.querySelector('#onboarding-confirmation');
			if (confirmationDialogEl) {
				confirmationDialog = new Dialog(confirmationDialogEl, {
					disableEscClose: true,
					urlRewrite: onboardingConfirmationStep,
				});
			}
		}

		if (!reenterEmailDialog) {
			// prepare reenter email window
			const reenterEmailDialogEl = document.querySelector('#onboarding-reenter-email');
			if (reenterEmailDialogEl) {
				reenterEmailDialog = new Dialog(reenterEmailDialogEl, {
					disableEscClose: true,
					urlRewrite: onboardingNotReceivedStep,
				});
				reenterEmailDialog.addEventListeners('.js-onboarding-reenter-email');
			}
		}
	}

	// Check common typos in email domain name
	function checkMisspelledEmail(domain, email) {
		var domainName = domain.trim().replace(/^http:\/\//, '').replace(/^https:\/\//, '').replace(/^www./, '').split(/[/?#]/)[0];
		var domainsList = [domainName];

		const emailChecker = emailMisspelled({ domains: domainsList });
		return emailChecker(email.trim());
	}

	function replaceSuggestedEmail(field, suggestedValue, callback, e) {
		e.preventDefault();
		field.value = suggestedValue;

		if (callback) {
			callback();
		}

		field.focus();
	}

	document.addEventListener('DOMContentLoaded', function () {
		prepareModals();

		/**
		 * Redirect old URLs for opening trial flow dialog to new URL
		 */
		if (window.location.hash.length >= 0 && (
			window.location.hash == '#onboarding-url' ||
			window.location.hash == '#onboarding-email' ||
			window.location.hash == '#onboarding-confirmation' ||
			window.location.hash == '#onboarding-reenter-email'
		)) {
			window.location.href = onboardingUrlStep;
		}

		var domainFromGet = getGetParameterByName('domain');

		if (domainFromGet) {
			// copy entered URL into URL modal window
			const urlFieldInDialog = urlDialog.dialogElement.querySelector('.js-trial-url');
			urlFieldInDialog.value = domainFromGet;
			onboardingData.domain = domainFromGet;
		}

		/**
		 * Open exact URL of onboarding modal window
		 * We will always show first URL window
		 */

		if (onboardingSteps.indexOf(window.location.pathname) >= 0 && window.location.pathname != onboardingUrlStep) {
			confirmationDialog.close(true);
			reenterEmailDialog.close(true);

			if (window.location.pathname == onboardingEmailStep && domainFromGet) {
				urlDialog.close(true);
				emailDialog.open();
			} else {
				emailDialog.close(true);
				urlDialog.open();
			}
		}
	});



	// store email sent in URL fragment to store (pattern: #s=vincent@contentkingapp.com)
	if (window.location.hash.length > 0) {
		var hash = window.location.hash;
		var match = hash.match(/#s=(.*)/);

		// check presence of pattern #s=vincent@contentkingapp.com in URL fragment
		if (match) {
			setStorageItem('onboarding_email', window.btoa(match[1]));

			// remove hash from URL
			if (window.history.pushState) {
				window.history.pushState(null, null, window.location.href.replace(match[0], ''));
			} else {
				window.location.hash = hash.replace(match[0], '');
			}

			prefillOnboardingEmailField();
		}
	}

	function prefillOnboardingEmailField() {
		var emailFields = document.querySelectorAll('.js-trial-email');
		var emailValue = getStorageItem('onboarding_email');

		if (emailFields.length > 0 && emailValue) {
			[].forEach.call(emailFields, function (emailField) {
				emailField.value = window.atob(emailValue);
			});
		}
	}

	prefillOnboardingEmailField();



	function shakeForm(form) {
		form.classList.add('shake-animation');

		setTimeout(function () {
			form.classList.remove('shake-animation');
		}, 1000);
	}



	function onePasswordWorkaround(form) {
		// trick how to prevent showing 1password icon when revealing error on submit
		form.querySelector('.js-submit-button').focus();

		setTimeout(function () {
			form.querySelector('input[type="text"],input[type="email"],input[type="url"]').focus();
		}, 0);
	}



	document.addEventListener('dialogopen', function (e) {
		const details = e.detail;

		if (!isTouchDevice) {
			if (details.connectedUrl == onboardingEmailStep) {
				// when we will prefill email address we will focus button immediately
				const onboardingEmail = getStorageItem('onboarding_email');

				if (onboardingEmail) {
					details.initialFocusableElement = details.dialogElement.querySelector('.js-submit-button');
				}
			}
		}

		if (details.connectedUrl == onboardingNotReceivedStep) {
			if (confirmationDialog.isActive) {
				confirmationDialog.close();
			}
		}
	});



	/**
	 * React on change of history state
	 */

	document.addEventListener('dialogpopstate', function (e) {
		const details = e.detail;

		if (
			onboardingSteps.indexOf(window.location.pathname) >= 0 && window.location.pathname != onboardingUrlStep &&
			details.connectedUrl &&
			onboardingSteps.indexOf(details.connectedUrl) >= 0
		) {
			emailDialog.close(true);
			confirmationDialog.close(true);
			reenterEmailDialog.close(true);

			urlDialog.open();
		}
	});



	function validateDomain(domain) {
		var data = {
			'ValidateDomain': {
				'context': 'marketingWebsite',
				'domain': domain,
			},
		};

		return new Promise((resolve, reject) => {
			var request = new XMLHttpRequest();
			request.open('POST', API_HOSTNAME + '/action?action=ValidateDomain', true)
			request.withCredentials = true;
			request.timeout = 50000;
			request.setRequestHeader('Content-Type', 'application/json');

			request.onerror = function () {
				reject({
					errorCode: 'error',
				});
			}

			request.ontimeout = function () {
				reject({
					errorCode: 'timeout',
				});
			}

			request.onreadystatechange = function () {
				// Request finished. Do processing here.
				if (this.response && this.readyState === XMLHttpRequest.DONE) {
					const response = JSON.parse(this.response);

					if (this.status === 200) {
						if (response.status === 'ok') {
							resolve('ok');
						} else {
							reject({
								errorCode: 'error',
							});
						}
					} else {
						if (response && response.code === 'website_already_monitored') {
							reject({
								errorCode: 'website-already-monitored',
							});
						} else if (response && response.code === 'unresolvable_domain') {
							if (response.errors && response.errors.unresolvable_domain && response.errors.unresolvable_domain.reason) {
								var reason = response.errors.unresolvable_domain.reason;

								if (reason == 'unspecified') {
									reject({
										errorCode: 'unresolvable-domain',
									});
								} else {
									reject({
										errorCode: 'unresolvable-domain-reason',
										reason: reason,
									});
								}
							} else {
								reject({
									errorCode: 'unresolvable-domain',
								});
							}

						} else if (response && response.code === 'target_redirected') {
							reject({
								errorCode: 'target-redirected',
								domain: response.errors.target_redirected.destination,
							});
						} else if (response && response.code === 'blacklisted_domain') {
							reject({
								errorCode: 'blacklisted-domain',
							});
						} else {
							reject({
								errorCode: 'error',
							});
						}
					}
				}
			}

			request.send(JSON.stringify(data));
		});
	}



	function processOnboarding() {
		onboardingData.locale = 'en_US';
		onboardingData.country = document.body.getAttribute('data-country');

		// pass campaign ID (detected in campaignTrafficDetection.js) to API
		var campaignSource = getStorageItem('campaign_id');
		if (campaignSource && campaignSource.length > 0) {
			onboardingData.campaignSource = campaignSource;
		}

		try {
			onboardingData.googleAnalyticsClientId = ga.getAll()[0].get('clientId');
		} catch (e) {
			onboardingData.googleAnalyticsClientId = null;
		}

		return new Promise((resolve, reject) => {
			var request = new XMLHttpRequest();
			request.open('POST', API_HOSTNAME + '/action?action=CreateTrialAccount', true)
			request.withCredentials = true;
			request.timeout = 50000;
			request.setRequestHeader('Content-Type', 'application/json');

			request.onerror = function () {
				reject({
					errorCode: 'error',
				});
			}

			request.ontimeout = function () {
				reject({
					errorCode: 'timeout',
				});
			}

			request.onreadystatechange = function () {
				// Request finished. Do processing here.
				if (this.response && this.readyState === XMLHttpRequest.DONE) {
					const response = JSON.parse(this.response);

					if (this.status === 200) {
						if (response.status === 'ok') {
							resolve({
								accountId: response.actions && response.actions.CreateTrialAccount && response.actions.CreateTrialAccount.account.id,
								intercomUserId: response.actions && response.actions.CreateTrialAccount && response.actions.CreateTrialAccount.intercomUserId,
							});
						} else {
							reject({
								errorCode: 'error',
							});
						}
					} else {
						if (response && (
							response.code === 'userAlreadyRegistered' || response.code === 'accountCannotBeRevived'
						)) {
							reject({
								errorCode: 'user-already-registered',
							});
						} else if (response && response.code === 'rateLimitExceeded') {
							reject({
								errorCode: 'rate-limit-exceeded',
							});
						} else if (response && response.code === 'disallowedEmail') {
							reject({
								errorCode: 'throw-away-domain',
							});
						} else if (response && response.code === 'trialAbuserEmail') {
							reject({
								errorCode: 'trial-abuser',
							});
						} else if (response && response.code === 'website_already_monitored') {
							reject({
								errorCode: 'website-already-monitored',
								step: 'url',
							});
						} else if (response && response.code === 'unresolvable_domain') {
							if (response.errors && response.errors.unresolvable_domain && response.errors.unresolvable_domain.reason) {
								var reason = response.errors.unresolvable_domain.reason;

								if (reason == 'unspecified') {
									reject({
										errorCode: 'unresolvable-domain',
										step: 'url',
									});
								} else {
									reject({
										errorCode: 'unresolvable-domain-reason',
										reason: reason,
										step: 'url',
									});
								}
							} else {
								reject({
									errorCode: 'unresolvable-domain',
									step: 'url',
								});
							}

						} else if (response && response.code === 'target_redirected') {
							reject({
								errorCode: 'target-redirected',
								domain: response.errors.target_redirected.destination,
								step: 'url',
							});
						} else if (response && response.code === 'blacklisted_domain') {
							reject({
								errorCode: 'blacklisted-domain',
								step: 'url',
							});
						} else if (response && response.code === 'conductorLoginRequired') {
							reject({
								errorCode: 'conductor-login-required',
							})
						} else if (response && response.code === 'conductorTrialStartRequired') {
							reject({
								errorCode: 'conductor-trial-start-required',
							})
						} else {
							reject({
								errorCode: 'error',
							});
						}
					}
				}
			}

			var data = {
				'CreateTrialAccount': onboardingData,
			};

			request.send(JSON.stringify(data));
		});
	}



	function resendActivation() {
		return new Promise((resolve, reject) => {
			var request = new XMLHttpRequest();
			request.open('POST', API_HOSTNAME + '/action?action=ResendActivationEmail', true)
			request.withCredentials = true;
			request.timeout = 30000;
			request.setRequestHeader('Content-Type', 'application/json');

			request.onerror = function () {
				reject({
					errorCode: 'error',
				});
			}

			request.ontimeout = function () {
				reject({
					errorCode: 'timeout',
				});
			}

			request.onreadystatechange = function () {
				// Request finished. Do processing here.
				if (this.response && this.readyState === XMLHttpRequest.DONE) {
					const response = JSON.parse(this.response);

					if (this.status === 200) {
						resolve('ok');
					} else {
						if (response && response.code === 'userAlreadyRegistered') {
							reject({
								errorCode: 'user-already-registered',
							});
						} else if (response && response.code === 'disallowedEmail') {
							reject({
								errorCode: 'throw-away-domain',
							});
						} else if (response && response.code === 'trialAbuserEmail') {
							reject({
								errorCode: 'trial-abuser',
							});
						} else if (response && response.code === 'unauthorized') {
							reject({
								errorCode: 'unauthorized',
							});
						} else {
							reject({
								errorCode: 'error',
							});
						}
					}
				}
			}

			var data = {
				'ResendActivationEmail': {
					email: onboardingData.email,
				},
			};

			request.send(JSON.stringify(data));
		});
	}



	const resetErrorMessages = function (form, includeGenericMessages = true, includeSpecificMessages = false) {
		var customErrorMessages = form.querySelectorAll('.custom-error');
		customErrorMessages.forEach(function (customErrorMessage) {
			resetAccessibleMessage(customErrorMessage);
			customErrorMessage.style.display = 'none';
		});

		if (includeGenericMessages) {
			var rateLimitErrorMessage = form.querySelector('.js-rate-limit-error');
			if (rateLimitErrorMessage) {
				resetAccessibleMessage(rateLimitErrorMessage);
				rateLimitErrorMessage.style.display = 'none';
			}

			var authenticationErrorMessage = form.querySelector('.js-authentication-error');
			if (authenticationErrorMessage) {
				resetAccessibleMessage(authenticationErrorMessage);
				authenticationErrorMessage.style.display = 'none';
			}

			var unexpectedErrorMessage = form.querySelector('.js-unexpected-error');
			resetAccessibleMessage(unexpectedErrorMessage);
			unexpectedErrorMessage.style.display = 'none';

			var timeoutErrorMessage = form.querySelector('.js-timeout-error');
			resetAccessibleMessage(timeoutErrorMessage);
			timeoutErrorMessage.style.display = 'none';
		}

		if (includeSpecificMessages) {
			var specificErrorMessages = form.querySelectorAll('.specific-error');
			specificErrorMessages.forEach(function (specificErrorMessage) {
				resetAccessibleMessage(specificErrorMessage);
				specificErrorMessage.style.display = 'none';

				// remove some custom listeners
				var suggestedEmail = specificErrorMessage.querySelector('.js-replace-suggested-email');
				if (suggestedEmail) {
					suggestedEmail.removeEventListener('click', replaceSuggestedEmail);
				}
			});
		}
	};



	const processDomainValidationError = function (form, response, delay = 0) {
		setTimeout(function () {
			shakeForm(form);

			const urlField = form.querySelector('.js-trial-url');

			// highlight input field only when no timeout error
			if (response.errorCode && response.errorCode != 'timeout' && response.errorCode != 'error') {
				urlField.classList.add('is-invalid-input');
			}
		}, delay);

		// Timeout is here because of shake animation.
		// We need to show bubbles after shaking to fix width calculation.
		setTimeout(function () {
			// reset all message (even generic)
			resetErrorMessages(form);

			if (!response.errorCode) {
				var unexpectedErrorMessage = form.querySelector('.js-unexpected-error');
				setAccessibleMessage(unexpectedErrorMessage);
				unexpectedErrorMessage.style.display = '';
			} else if (response.errorCode == 'timeout') {
				var timeoutErrorMessage = form.querySelector('.js-timeout-error');
				setAccessibleMessage(timeoutErrorMessage);
				timeoutErrorMessage.style.display = '';
			} else if (response.errorCode == 'website-already-monitored') {
				var alreadyMonitoredMessage = form.querySelector('.js-website-already-monitored');
				setAccessibleMessage(alreadyMonitoredMessage);
				alreadyMonitoredMessage.style.display = '';
			} else if (response.errorCode == 'unresolvable-domain') {
				var unresolvableDomainMessage = form.querySelector('.js-unresolvable-domain');
				setAccessibleMessage(unresolvableDomainMessage);
				unresolvableDomainMessage.style.display = '';
			} else if (response.errorCode == 'unresolvable-domain-reason') {
				switch (response.reason) {
					case 'connect':
						var unresolvableDomainMessage = form.querySelector('.js-unresolvable-domain-connect');
						setAccessibleMessage(unresolvableDomainMessage);
						unresolvableDomainMessage.style.display = '';
						break;
					case 'empty_response':
						var unresolvableDomainMessage = form.querySelector('.js-unresolvable-domain-empty-response');
						setAccessibleMessage(unresolvableDomainMessage);
						unresolvableDomainMessage.style.display = '';
						break;
					case 'size_limit':
						var unresolvableDomainMessage = form.querySelector('.js-unresolvable-domain-size-limit');
						setAccessibleMessage(unresolvableDomainMessage);
						unresolvableDomainMessage.style.display = '';
						break;
					case 'time_limit':
						var unresolvableDomainMessage = form.querySelector('.js-unresolvable-domain-time-limit');
						setAccessibleMessage(unresolvableDomainMessage);
						unresolvableDomainMessage.style.display = '';
						break;
					case 'waf':
						var unresolvableDomainMessage = form.querySelector('.js-unresolvable-domain-waf');
						setAccessibleMessage(unresolvableDomainMessage);
						unresolvableDomainMessage.style.display = '';
						break;
					default:
						var unresolvableDomainMessage = form.querySelector('.js-unresolvable-domain');
						setAccessibleMessage(unresolvableDomainMessage);
						unresolvableDomainMessage.style.display = '';
				}
			} else if (response.errorCode == 'target-redirected') {
				var targetRedirectedMessage = form.querySelector('.js-target-redirected');
				setAccessibleMessage(targetRedirectedMessage);
				targetRedirectedMessage.style.display = '';
				form.querySelector('.js-target-redirected-domain').innerHTML = response.domain;
			} else if (response.errorCode == 'blacklisted-domain') {
				var blacklistedDomainMessage = form.querySelector('.js-blacklisted-domain');
				setAccessibleMessage(blacklistedDomainMessage);
				blacklistedDomainMessage.style.display = '';
			} else {
				var unexpectedErrorMessage = form.querySelector('.js-unexpected-error');
				setAccessibleMessage(unexpectedErrorMessage);
				unexpectedErrorMessage.style.display = '';
			}
		}, 1000 + delay);
	};



	/**
	 * Trim value in URL field on blur
	 */

	const onboardingUrlFields = document.querySelectorAll('.js-trial-url');
	Array.prototype.forEach.call(onboardingUrlFields, function (onboardingUrlField) {
		onboardingUrlField.addEventListener('blur', function () {
			let value = this.value;

			if (value !== '') {
				this.value = value.trim();

				// trigger re-validation
				trigger(this, 'change');
			}
		});
	});



	/**
	 * Submit URL on the page and open on-boarding process
	 * or
	 * Submit URL in on-boarding process
	 */

	var urlForms = document.querySelectorAll('.js-submit-url-form, .js-submit-url-start-onboarding');
	for (var i = 0; i < urlForms.length; i++) {
		var formEl = urlForms[i];

		formEl.addEventListener('formvalid', (ev) => {
			const details = ev.detail;
			const form = details.formElement;
			const urlField = form.querySelector('.js-trial-url');

			resetErrorMessages(form, false);

			const _resetInvalidUrlFieldMessage = function () {
				resetErrorMessages(form, false);
				urlField.classList.remove('is-invalid-input');
			};

			var domain = urlField.value.trim();

			var submitButton = form.querySelector('.js-submit-button');
			trigger(submitButton, 'progress');

			validateDomain(urlField.value).then(function () {
				// close url dialog when open
				if (urlDialog && urlDialog.isActive) {
					urlDialog.close();
				}

				// open email modal window
				if (emailDialog) {
					emailDialog.open();
				}

				// GA tracking using Google Tag Manager
				dataLayer.push({
					'event': 'gaEvent',
					'eventCategory': 'Trial forms',
					'eventAction': 'Submit',
					'eventLabel': 'Domain: ' + domain,
				});

				urlField.classList.remove('is-invalid-input');
				urlField.removeEventListener('keyup', _resetInvalidUrlFieldMessage);

				// when we are in in-page domain form
				if (!urlDialog) {
					var search = window.location.search;
					if (search.length == 0) {
						search += '?domain=' + encodeURI(domain);
					} else {
						search += '&domain=' + encodeURI(domain);
					}
					window.location.href = onboardingEmailStep + search;
				}
			}).catch(function (data) {
				processDomainValidationError(form, data);

				urlField.addEventListener('keyup', _resetInvalidUrlFieldMessage);
			}).finally(function () {
				trigger(submitButton, 'active');
			});
		});

		formEl.addEventListener('elementvalid', (ev) => {
			const details = ev.detail;

			if (details && details.validator && details.validator.formElement) {
				resetErrorMessages(details.validator.formElement, false);
			}
		});

		formEl.addEventListener('elementinvalid', (ev) => {
			const details = ev.detail;

			if (details && details.validator && details.validator.formElement) {
				resetErrorMessages(details.validator.formElement, false);
			}
		});

		formEl.addEventListener('submit', function (ev) {
			const urlField = this.querySelector('.js-trial-url');
			onboardingData.domain = urlField.value.trim();
			ev.preventDefault();
		});
	}



	/**
	 * Submit email in on-boarding process
	 */

	var emailForms = document.querySelectorAll('.js-submit-email-form');
	for (var i = 0; i < emailForms.length; i++) {
		const formEl = emailForms[i];
		const emailField = formEl.querySelector('.js-trial-email');

		emailField.addEventListener('keyup', function () {
			var isEmailValid = FormValidator.defaults.patterns.email.test(this.value);

			if (isEmailValid) {
				// Email seems to be valid. Let's check common typos in email domain
				var suggestions = checkMisspelledEmail(onboardingData.domain, this.value);

				if (suggestions && suggestions.length > 0) {
					var suggestion = suggestions[0];

					var misspelledEmailMessage = formEl.querySelector('.js-misspelled-email');
					misspelledEmailMessage.querySelector('.js-suggested-email').innerHTML = suggestion.corrected;
					setAccessibleMessage(misspelledEmailMessage);
					misspelledEmailMessage.style.display = '';
					const callback = () => resetErrorMessages(formEl, false, true);
					misspelledEmailMessage.querySelector('.js-replace-suggested-email').addEventListener('click', replaceSuggestedEmail.bind(this, this, suggestion.corrected, callback))
				} else {
					resetErrorMessages(formEl, false, true);
				}
			} else {
				resetErrorMessages(formEl, false, true);
			}
		});

		formEl.addEventListener('formvalid', (ev) => {
			const details = ev.detail;
			const form = details.formElement;
			const emailField = form.querySelector('.js-trial-email');

			resetErrorMessages(form, false, true);

			const _resetInvalidUrlFieldMessage = function () {
				resetErrorMessages(form, false);
				emailField.classList.remove('is-invalid-input');
			};

			var email = emailField.value.trim();
			onboardingData.email = email;

			var submitButton = form.querySelector('.js-submit-button');
			trigger(submitButton, 'progress');

			processOnboarding().then(function (response) {
				// close url dialog when open
				if (emailDialog.isActive) {
					emailDialog.close();
				}

				// open confirmation step
				confirmationDialog.open();

				removeStorageItem('onboarding_email');

				// GA tracking using Google Tag Manager
				dataLayer.push({
					'event': 'gaEvent',
					'eventCategory': 'Trial forms',
					'eventAction': 'Submit',
					'eventLabel': 'Email: ' + email,
				});

				if (response.intercomUserId) {
					// UserID Created (trigger after user submits valid email - #onboarding-confirmation)
					dataLayer.push({
						'event': 'gaEvent',
						'eventCategory': 'User',
						'eventAction': 'UserID Created',
						'userId': response.intercomUserId,
					});
				}

				if (response.accountId) {
					/* jshint ignore:start */
					(function (t, a, p) { t.TapfiliateObject = a; t[a] = t[a] || function () { (t[a].q = t[a].q || []).push(arguments) } })(window, 'tap');

					tap('create', '4164-d1d06e');

					// Track conversion from affiliate
					tap('conversion', response.accountId, 0);
					/* jshint ignore:end */
				}

				emailField.classList.remove('is-invalid-input');
				emailField.removeEventListener('keyup', _resetInvalidUrlFieldMessage);

				// prefill email into email field in reenter email dialog
				reenterEmailDialog.dialogElement.querySelector('.js-reenter-email').value = email;
			}).catch(function (data) {
				if (data.errorCode && data.step == 'url') {
					emailDialog.close();
					urlDialog.open();

					const urlForm = urlDialog.dialogElement.querySelector('.js-submit-url-form');
					processDomainValidationError(urlForm, data, 500);
				} else if (data.errorCode === 'conductor-login-required') {
					location.href = 'https://app.conductor.com/login.html?ckBanner=true&redirectUri=https://contentking.app.conductor.com/';
				} else if (data.errorCode === 'conductor-trial-start-required') {
					location.href = 'https://app.conductor.com/login.html?loginToStartCKTrialBanner=true&redirectUri=%2Fu%2Fcontentking-signup';
				} else {
					shakeForm(form);

					// highlight input field only when no timeout error
					if (data.errorCode && (data.errorCode == 'user-already-registered' || data.errorCode == 'throw-away-domain')) {
						emailField.classList.add('is-invalid-input');
					}

					// Timeout is here because of shake animation.
					// We need to show bubbles after shaking to fix width calculation.
					setTimeout(function () {
						// reset all message (even generic)
						resetErrorMessages(form);

						if (!data.errorCode) {
							var unexpectedErrorMessage = form.querySelector('.js-unexpected-error');
							setAccessibleMessage(unexpectedErrorMessage);
							unexpectedErrorMessage.style.display = '';
						} else if (data.errorCode == 'timeout') {
							var timeoutErrorMessage = form.querySelector('.js-timeout-error');
							setAccessibleMessage(timeoutErrorMessage);
							timeoutErrorMessage.style.display = '';
						} else if (data.errorCode == 'user-already-registered') {
							var userAlreadyRegisteredMessage = form.querySelector('.js-user-already-registered');
							setAccessibleMessage(userAlreadyRegisteredMessage);
							userAlreadyRegisteredMessage.style.display = '';
						} else if (data.errorCode == 'rate-limit-exceeded') {
							var rateLimitErrorMessage = form.querySelector('.js-rate-limit-error');
							setAccessibleMessage(rateLimitErrorMessage);
							rateLimitErrorMessage.style.display = '';
						} else if (data.errorCode == 'throw-away-domain') {
							var throwAwayDomainMessage = form.querySelector('.js-throw-away-domain');
							setAccessibleMessage(throwAwayDomainMessage);
							throwAwayDomainMessage.style.display = '';
						} else if (data.errorCode == 'trial-abuser') {
							var trialAbuserMessage = form.querySelector('.js-trial-abuser');
							setAccessibleMessage(trialAbuserMessage);
							trialAbuserMessage.style.display = '';
						} else {
							var unexpectedErrorMessage = form.querySelector('.js-unexpected-error');
							setAccessibleMessage(unexpectedErrorMessage);
							unexpectedErrorMessage.style.display = '';
						}

						// trick how to prevent showing 1password icon when revealing error on submit
						onePasswordWorkaround(form);
					}, 1000);
				}

				emailField.addEventListener('keyup', _resetInvalidUrlFieldMessage);
			}).finally(function () {
				trigger(submitButton, 'active');
			});
		});

		formEl.addEventListener('elementvalid', (ev) => {
			const details = ev.detail;

			if (details && details.validator && details.validator.formElement) {
				resetErrorMessages(details.validator.formElement, false);
			}
		});

		formEl.addEventListener('elementinvalid', (ev) => {
			const details = ev.detail;

			if (details && details.validator && details.validator.formElement) {
				resetErrorMessages(details.validator.formElement, false, true);
			}
		});

		formEl.addEventListener('submit', (ev) => {
			ev.preventDefault();

			return false;
		});
	}



	/**
	 * Re-enter email in on-boarding process
	 */

	var reenterEmailForms = document.querySelectorAll('.js-reenter-email-form');
	for (var i = 0; i < reenterEmailForms.length; i++) {
		var formEl = reenterEmailForms[i];
		const emailField = formEl.querySelector('.js-reenter-email');

		emailField.addEventListener('keyup', function () {
			var isEmailValid = FormValidator.defaults.patterns.email.test(this.value);

			if (isEmailValid) {
				// Email seems to be valid. Let's check common typos in email domain
				var suggestions = checkMisspelledEmail(onboardingData.domain, this.value);

				if (suggestions && suggestions.length > 0) {
					var suggestion = suggestions[0];

					var misspelledEmailMessage = formEl.querySelector('.js-misspelled-email');
					misspelledEmailMessage.querySelector('.js-suggested-email').innerHTML = suggestion.corrected;
					setAccessibleMessage(misspelledEmailMessage);
					misspelledEmailMessage.style.display = '';
					const callback = () => resetErrorMessages(formEl, false, true);
					misspelledEmailMessage.querySelector('.js-replace-suggested-email').addEventListener('click', replaceSuggestedEmail.bind(this, this, suggestion.corrected, callback))
				} else {
					resetErrorMessages(formEl, false, true);
				}
			} else {
				resetErrorMessages(formEl, false, true);
			}
		});

		formEl.addEventListener('formvalid', (ev) => {
			const details = ev.detail;
			const form = details.formElement;
			const emailField = form.querySelector('.js-reenter-email');

			resetErrorMessages(form, false, true);

			const _resetInvalidUrlFieldMessage = function () {
				resetErrorMessages(form, false);
				emailField.classList.remove('is-invalid-input');
			};

			var email = emailField.value.trim();
			onboardingData.email = email;

			var submitButton = form.querySelector('.js-submit-button');
			trigger(submitButton, 'progress');

			resendActivation().then(function () {
				// GA tracking using Google Tag Manager
				dataLayer.push({
					'event': 'gaEvent',
					'eventCategory': 'Trial forms',
					'eventAction': 'Submit',
					'eventLabel': 'Email: ' + email,
				});

				resetErrorMessages(form);

				// open confirmation step
				confirmationDialog.open();
				reenterEmailDialog.close();

				emailField.classList.remove('is-invalid-input');
				emailField.removeEventListener('keyup', _resetInvalidUrlFieldMessage);
			}).catch(function (data) {
				shakeForm(form);

				// highlight input field only when no timeout error
				if (data.errorCode && (data.errorCode == 'user-already-registered' || data.errorCode == 'throw-away-domain')) {
					emailField.classList.add('is-invalid-input');
				}

				// Timeout is here because of shake animation.
				// We need to show bubbles after shaking to fix width calculation.
				setTimeout(function () {
					// reset all message (even generic)
					resetErrorMessages(form);

					if (!data.errorCode) {
						var unexpectedErrorMessage = form.querySelector('.js-unexpected-error');
						setAccessibleMessage(unexpectedErrorMessage);
						unexpectedErrorMessage.style.display = '';
					} else if (data.errorCode == 'timeout') {
						var timeoutErrorMessage = form.querySelector('.js-timeout-error');
						setAccessibleMessage(timeoutErrorMessage);
						timeoutErrorMessage.style.display = '';
					} else if (data.errorCode == 'user-already-registered') {
						var userAlreadyRegisteredMessage = form.querySelector('.js-user-already-registered');
						setAccessibleMessage(userAlreadyRegisteredMessage);
						userAlreadyRegisteredMessage.style.display = '';
					} else if (data.errorCode == 'unauthorized') {
						var authenticationErrorMessage = form.querySelector('.js-authentication-error');
						setAccessibleMessage(authenticationErrorMessage);
						authenticationErrorMessage.style.display = '';
					} else if (data.errorCode == 'throw-away-domain') {
						var throwAwayDomainMessage = form.querySelector('.js-throw-away-domain');
						setAccessibleMessage(throwAwayDomainMessage);
						throwAwayDomainMessage.style.display = '';
					} else if (data.errorCode == 'trial-abuser') {
						var trialAbuserMessage = form.querySelector('.js-trial-abuser');
						setAccessibleMessage(trialAbuserMessage);
						trialAbuserMessage.style.display = '';
					} else {
						var unexpectedErrorMessage = form.querySelector('.js-unexpected-error');
						setAccessibleMessage(unexpectedErrorMessage);
						unexpectedErrorMessage.style.display = '';
					}

					// trick how to prevent showing 1password icon when revealing error on submit
					onePasswordWorkaround(form);
				}, 1000);

				emailField.addEventListener('keyup', _resetInvalidUrlFieldMessage);
			}).finally(function () {
				trigger(submitButton, 'active');
			});
		});

		formEl.addEventListener('elementvalid', (ev) => {
			const details = ev.detail;

			if (details && details.validator && details.validator.formElement) {
				resetErrorMessages(details.validator.formElement, false);
			}
		});

		formEl.addEventListener('elementinvalid', (ev) => {
			const details = ev.detail;

			if (details && details.validator && details.validator.formElement) {
				resetErrorMessages(details.validator.formElement, false, true);
			}
		});

		formEl.addEventListener('submit', (ev) => {
			ev.preventDefault();

			return false;
		});
	}
})();
